import React, { useContext } from 'react';
import classNames from 'classnames';
import { string } from 'prop-types';
import { CarouselContext } from '../../top_filters_carousel';
import { AppContext } from '../../../context/listingsContext';
import { VIEW_ALL_COMPONENT } from '../../top_filters_carousel/constants';
import tracker from '../../../../service/tracker';
import { BI_SOURCES, EVENTS_MAPPING } from '../../../../utils/constants';
import ViewAllTile from '../view_all_tile/viewAllTile';
import { LIST_TYPES } from '../view_all_tile/constants';
import { applyFilter } from './utils';
import imageMapper from './imageMapper';
import '../index.scss';

const FilterTile = ({ id, alias }) => {
    const { filterId, subCategoryId, tileSize, allFilters, setCollapseCarousel, setStepIndex, stepIndex, isLastStep, stepNum } = useContext(CarouselContext);
    const { dispatch, filter: { active: activeFilters, selected: selectedFilters } } = useContext(AppContext);
    const subCategoryIcons = imageMapper[subCategoryId];
    const image = subCategoryIcons && subCategoryIcons[id];

    const clickedViewAll = () => {
        tracker.trackTileFilter(EVENTS_MAPPING.FILTERS_VIEW_ALL, filterId, stepNum);
    };

    const onTileClick = () => {
        !isLastStep && setStepIndex(stepIndex + 1);

        applyFilter({
            filterId,
            value: id,
            activeFilters,
            selectedFilters,
            setCollapseCarousel,
            dispatch,
            allFilters,
            isLastStep,
            stepNum,
            source: BI_SOURCES.VISUAL_FILTERS
        });
    };

    if (id === VIEW_ALL_COMPONENT) {
        return (
            <ViewAllTile alias={alias}
                tileSize={tileSize}
                items={allFilters}
                listType={LIST_TYPES.FILTERS}
                onOpen={clickedViewAll}/>
        );
    }

    return (
        <a className={classNames('tile filter-tile box-shadow-z2', tileSize)}
            onClick={onTileClick}>
            <img src={image} alt={alias}/>
            <p className="text-body-2">{alias}</p>
        </a>
    );
};

FilterTile.propTypes = {
    id: string,
    alias: string
};

export default FilterTile;
